export const DISPLAYSIZECHANGE = 'DISPLAYSIZECHANGE';
export const LOGINSTATE = 'LOGINSTATE';
export const LOADING = 'LOADING';
export const LANGUAGECODE = 'LANGUAGECODE';
export const PAGEISLOADED = 'PAGEISLOADED';
export const AUTHCHECKED = 'AUTHCHECKED';

export const mainConst = {
	DisplaySizeChange: 0,
	loginState: false,
	authChecked: false,
	loading: false,
	languageCode: '',
	pageIsLoaded: false,
};

